import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHandHoldingDollar, faWallet, faCreditCard, faArrowUpFromBracket, faCircleNotch, faArrowRight, faLessThanEqual, faUser } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";
import { useNavigate, useLocation, Link } from 'react-router-dom'
import { toast } from 'react-hot-toast';

function Withdraw3() {
  const { user } = useUser();
  const { state } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const lsCAmount = localStorage.getItem('withdraw.camount');
    const lsAmount = localStorage.getItem('withdraw.amount');
    const hasType = state?.camount || state?.amount || lsCAmount || lsAmount;
    if (!hasType) {
        navigate('/withdraw1', { replace: true });
    } else {
        setLoading(false);
    }
  }, [state, navigate]);
  const [error, setError] = useState(false);
  const [coinbal, setCoinbal] = useState(() => {return state?.coinbal ?? localStorage.getItem('withdraw.coinbal') ?? 0;});
  const [symbol, setSymbol] = useState(() => {return state?.symbol ?? localStorage.getItem('withdraw.symbol') ?? '';});
  const [price, setPrice] = useState(() => {return state?.price ?? localStorage.getItem('withdraw.price') ?? '';});
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [route, setRoute] = useState(() => {return state?.route ?? localStorage.getItem('withdraw.route') ?? 'assets';});
  const [type, setType] = useState(() => {return state?.type ?? localStorage.getItem('withdraw.type') ?? 'Crypto';});
  const [camount, setCamount] = useState(() => {return state?.camount ?? localStorage.getItem('withdraw.camount') ?? '';});
  const [asset, setAsset] = useState(() => {return state?.asset ?? localStorage.getItem('withdraw.asset') ?? 'BTC';});
  const [amount, setAmount] = useState(() => {return state?.amount ?? localStorage.getItem('withdraw.amount') ?? '';});
  const [address, setAddress] = useState(() => {return state?.address ?? localStorage.getItem('withdraw.address') ?? '';});
  const [paymentDetails, setPaymentDetails] = useState(() => {return state?.paymentDetails ?? localStorage.getItem('withdraw.paymentDetails') ?? '';});
  const [withdrawCode, setWithdrawCode] = useState(localStorage.getItem('withdraw.withdrawCode') || '');
  const [sentCode, setSentCode] = useState(user?.withdraw_code);
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(true);
  const sendCode = () =>{
    fetch(`${process.env.REACT_APP_API_URL}controller/withdraw.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ getCode: 1})
    })
    .then(response => response.json())
    .then(data => {
        if (data.status === "success") {
          setSentCode(data.code);
          toast.success("Code sent to your email.");
        }else{
          toast.error("Failed to send code. Please try again.");
        }
    })
    .catch(err => {
        console.error(err)
        toast.error("Failed to send code. Please try again.");
    })
  }
  function validateCode (value){
    setWithdrawCode(value);
    if(Number(value) != Number(sentCode)){
      setError(true);
    }else{
      setError(false);
    }
  }
  useEffect(() => {
    if(withdrawCode && !error){
      setDisable(false);
    }else{
      setDisable(true);
    }
  }, [withdrawCode, error]);
  
  if (loading) {
    return <div style={{ textAlign: "center", marginTop: "20%" }}><FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '30px', color: '#ff6b35', opacity: '0.5'}} spin /></div>;
  }

  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Deposit" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Deposit" icon={<FontAwesomeIcon icon={faHandHoldingDollar} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="container mt-5">
                <div className="row">
                    <div className="col-lg-8 offset-lg-2 mb-5">
                        <h5 className="mb-0" style={{fontWeight:'900'}}>Withdraw Funds</h5>
                        <p className="mb-0">Withdraw from from your account</p>
                        <div className="mt-5 d-flex align-items-center progressD" style={{gap:'20px'}}>
                          <Link to="/withdraw" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px'}}>
                                <FontAwesomeIcon icon={faUser} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-prime text-nowrap" style={{fontSize:'12px'}}>Withdrawal Account</p>
                          </Link>
                          <div className="bg-prime" style={{height:'3px',maxWidth:'200px',width:'100%'}}></div>
                          <Link to="/withdraw1" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px'}}>
                              <FontAwesomeIcon icon={faWallet} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-prime text-nowrap" style={{fontSize:'12px'}}>Method Selection</p>
                          </Link>
                          <div className="bg-prime" style={{height:'3px',maxWidth:'200px',width:'100%'}}></div>
                          <Link to="/withdraw2" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px'}}>
                              <FontAwesomeIcon icon={faCreditCard} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-nowrap text-prime" style={{fontSize:'12px'}}>Withdrawal Details</p>
                          </Link>
                          <div className="bg-prime" style={{height:'3px',maxWidth:'200px',width:'100%'}}></div>
                          <Link to="/withdraw3" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px'}}>
                              <FontAwesomeIcon icon={faArrowUpFromBracket} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-nowrap text-prime" style={{fontSize:'12px'}}>Withdrawal Code</p>
                          </Link>
                          <div style={{height:'3px',backgroundColor:'#ffffff0c',maxWidth:'200px',width:'100%'}}></div>
                          <Link to="/withdraw4" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                              <FontAwesomeIcon icon={faCircleCheck} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-nowrap" style={{fontSize:'12px'}}>Review & Submit</p>
                          </Link>
                        </div>
                        <div className="mycard p-3 mt-4">
                          <div className="row">
                            <div className="col-12">
                              <h5 className="mb-1" style={{fontWeight:'900'}}>Verify with Withdrawal Code</h5>
                              <div className="mycard p-3 rounded-2 my-3" style={{backgroundColor:'#ff6b350d'}}>
                                <p className="mb-0 text-prime" style={{fontSize:'14px'}}>For security purposes, your withdrawal code is sent only via email. You cannot set it manually. Please check your email for the temporary code.</p>
                              </div>
                              <div className="d-flex align-items-center justify-content-between">
                                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Withdrawal code:</label>
                                <label className="fw-semibold mt-2 mb-1 text-prime" style={{fontSize: '12px',cursor: 'pointer'}} onClick={sendCode}>Send Code</label>
                              </div>
                              <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                                <input 
                                    type="text"
                                    placeholder={`XXXX`}
                                    className="inputNone w-100 py-1 text-center"
                                    value={withdrawCode}
                                    onChange={(e) => validateCode(e.target.value)}
                                />
                              </div>
                              {error && (
                                <p className="mb-0 text-danger fs-7 mt-1">Invalid withdrawal code. Please try again.</p>
                              )}
                              <hr/>
                              <div className="d-flex justify-content-end">
                                {disable ? (
                                    <div className="myBtn mt-4 text-center px-4 py-3 rounded-2 d-block disabled">Next <FontAwesomeIcon icon={faArrowRight} style={{fontSize: '14px'}} /></div>
                                ) : (
                                    <Link to="/withdraw4" state={{type:type, route:route, camount:camount, asset:asset, amount:amount, address:address, paymentDetails:paymentDetails, price:price, symbol:symbol, coinbal:coinbal, withdrawCode:withdrawCode}} className="myBtn mt-4 text-center px-4 py-3 rounded-2 d-block" onClick={() => {
                                      localStorage.setItem('withdraw.withdrawCode', withdrawCode);
                                    }}>Next <FontAwesomeIcon icon={faArrowRight} style={{fontSize: '14px'}} /></Link>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default Withdraw3